import {createRouter, createWebHistory} from "vue-router";
import {initHttpEndpoints, httpPost, httpGet, httpDownloadFile} from 'fallco-frontend-framework/src/js/classes/HttpManager/http_caller.js'
import endpoints from './api/api.js'
import {permissions} from './acl-permissions.js'
import AclVue from './plugins/AclVue/acl-vue.js'
import { createPinia } from 'pinia'
import {delete_cross, arrows_down, arrows_up, alert_triangle, alert_warning} from "./svg/svgs.js"
import {cloneDeep, merge} from "lodash";
import FallcoHelper from './plugins/FallcoHelper/fallco-helper.js';
import frameworkBaseInstance from 'fallco-frontend-framework/src/vue/base_instance.js'
import frontendFrameworkVueComponents from 'fallco-frontend-framework/src/vue/index.js'
import BaseInputArray from './core/components/form/BaseInputArray.vue'
import {useDesignSystem} from "./composable/useDesignSystem.js";
import {addCustomVueDirective, customizeVueWarningAndError, setDevToolPlugin} from './base_instance_utilities.js'

// inizializza gli endpoints di progetto nell'http client del framework
initHttpEndpoints(endpoints)

const designSystem = useDesignSystem();

/**
 * Gestore di istanze vue
 * @param app
 * @param rootComponent
 * @param mountElement
 * @param have_vuex
 * @param have_routing
 * @param plugins
 * @param import_framework_components
 * @returns {*}
 */
export function createCRMVueInstance(
  app,
  rootComponent,
  mountElement,
  have_vuex = false,
  have_routing = false,
  plugins = null,
  import_framework_components = false) {
  // aggiunta di pinia (vue state manager)
  if(have_vuex) {
    const pinia = createPinia()
    app.use(pinia)
  }

  // aggiunta di vue router
  if(have_routing) {
    app.use(createRouter({
      history: createWebHistory(),
      routes: have_routing['preventivo'] !== undefined ? have_routing['routes'] : [ { path: have_routing.path, name: have_routing.name, component: rootComponent }],
    }))
  }

  // aggiunta di plugin
  Object.keys(frameworkBaseInstance.BaseVuePlugin).forEach((plugin_name) => {
    app.use(frameworkBaseInstance.BaseVuePlugin[plugin_name])
  })

  if(plugins) app.use(AclVue, {acl: permissions})

  const helperFiles = require.context('.', true,  /\.helper\.js$/);
  const helpers = {};

  /**
   * Cicla tutti i file .helper.js e ne genera dei moduli richiamabili
   */
  helperFiles.keys().forEach(filename => {
    let moduleName = filename
      .replace(/(\.\/|\.helper\.js)/g, '')
      .replace(/^\w/, c => c.toUpperCase())

    moduleName = moduleName.split('/')
    moduleName = moduleName[moduleName.length - 1];

    helpers[moduleName] = helperFiles(filename).default || helperFiles(filename);
  });

  app.use(FallcoHelper, helpers)

  // aggiunta di utilities globali
  app.provide('$AxiosClient', {post: httpPost, get: httpGet, download: httpDownloadFile});
  app.provide('$L_', {cloneDeep: cloneDeep, merge: merge});
  app.provide('$BaseVueUtils', frameworkBaseInstance.BaseVueUtils)
  app.provide('$DesignSystem', designSystem)
  app.provide('isPopulated', (element) => {
    return element && element.length > 0
  })

  // aggiunge all'istanza Vue le direttive custom
  addCustomVueDirective(app);

  // inizializzazione dei componenti base del framework
  app.use(frontendFrameworkVueComponents, {
  'base-tabs': {
    icon: {
      warning: alert_warning
    }
  },
  'base-input-password': {
    icon: {
      alert: alert_triangle
    }
  },
  'base-input-text': {
    icon: {
      alert: alert_triangle
    }
  },
  'base-input-text-floating-label': {
    icon: {
      alert: alert_triangle
    }
  },
  'base-accordion': {
    icon: {
      chevronUp: arrows_up,
      chevronDown: arrows_down
    }
  },
  'base-alert-message': {
    icon: {
      closeIcon: delete_cross
    }
  },
  'base-modal': {
    icon: {
      iconClose: delete_cross
    }
  },
})

  // importo i componenti globali specifici per il CRM
  app.component('base-input-array', BaseInputArray)

  // Customizzazione degli errori e warning di vue
  customizeVueWarningAndError(app)

  setDevToolPlugin(app);

  // mount dell'istanza vue
  app.mount(mountElement)

  return app;
}